// extracted by mini-css-extract-plugin
export default {"container":"Collapsable_container__oLg-6","title":"Collapsable_title__ES82I","chevron":"Collapsable_chevron__D1KQe","chevronOpen":"Collapsable_chevronOpen__z8hy-"};